import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import GenerateButton from "@/components/AccountParts/GenerateButton.vue"
import { generateEmail } from "@/services/functions"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailGenerate',
  props: {
    buttonName: {},
    driverId: {},
    officeId: {},
    class: {}
  },
  emits: ['update:modelValue', 'displayError'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const mailGenerationErrorMessage: string[] = [i18n.global.t('pages.accounts.messages.mailGenerationError')]

function makeEmail() {
  if (!props.driverId || !props.officeId) return emits('displayError', mailGenerationErrorMessage)
  const email = generateEmail(props.driverId, props.officeId)
  emits("update:modelValue",  email)
  emits('displayError', [])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.class)
  }, [
    _createVNode(GenerateButton, {
      buttonName: props.buttonName,
      onGenerate: makeEmail
    }, null, 8, ["buttonName"])
  ], 2))
}
}

})